import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const DeactivatedLabel: React.VFC = () => {
  return (
    <div className={styles['label']} data-testid="offers_history_deactivated_label">
      <UIText3 color="white_100">Снято с продажи</UIText3>
    </div>
  );
};
